/**
 * Amplitude analytics for funnel and engagement tracking.
 * Use track() for button clicks and key events; use setUserId after login.
 */

function getAmplitude() {
  if (typeof window === 'undefined' || !window.amplitude) return null;
  return window.amplitude;
}

/**
 * Track an event in Amplitude (for funnels and engagement).
 * @param {string} eventName - e.g. "Clicked Create Lesson Plan", "Viewed Lesson Plan"
 * @param {Object} [properties] - optional: { lesson_plan_id, screen_name, ... }
 */
export function track(eventName, properties = {}) {
  const amp = getAmplitude();
  if (!amp) return;
  try {
    amp.track(eventName, {
      ...properties,
      timestamp: new Date().toISOString(),
    });
  } catch (e) {
    console.warn('[analytics] track failed:', e);
  }
}

/**
 * Set the user ID after login (so Amplitude can attribute events and build funnels per user).
 * @param {string|number} userId
 */
export function setUserId(userId) {
  const amp = getAmplitude();
  if (!amp) return;
  try {
    amp.setUserId(String(userId));
  } catch (e) {
    console.warn('[analytics] setUserId failed:', e);
  }
}

/**
 * Set user properties (e.g. after login) for segmentation.
 * @param {Object} props - e.g. { email, name }
 */
export function setUserProperties(props) {
  const amp = getAmplitude();
  if (!amp) return;
  try {
    const identify = amp.Identify ? new amp.Identify() : null;
    if (identify && typeof identify.set === 'function') {
      Object.entries(props).forEach(([key, value]) => {
        if (value != null) identify.set(key, value);
      });
      amp.identify(identify);
    }
  } catch (e) {
    console.warn('[analytics] setUserProperties failed:', e);
  }
}

/**
 * Reset user (e.g. on logout) so next user isn't attributed to previous.
 */
export function resetUser() {
  const amp = getAmplitude();
  if (!amp) return;
  try {
    if (typeof amp.setUserId === 'function') amp.setUserId(null);
    if (typeof amp.reset === 'function') amp.reset();
  } catch (e) {
    console.warn('[analytics] reset failed:', e);
  }
}
